import React, { useState } from 'react'
import SwiperCore, { Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTimes } from '@fortawesome/free-solid-svg-icons'

import './Gallery.css'

SwiperCore.use([Navigation])

const Gallery = ({ title, images = [], onClose }) => {
  const [activeImageIndex, setActiveImageIndex] = useState(1)

  return (
    <div className="gallery-wrapper">
      <div className="gallery-image-item-wrapper">
        <div className="gallery-item-wrapper gallery-item-header">
          <div>
            <p><strong>{title}</strong></p>
          </div>
          <div>
            <p>{activeImageIndex}/{images.length}</p>
          </div>
        </div>
        <Swiper
          onSlideChange={(swiper) => setActiveImageIndex(swiper.activeIndex + 1)}
          navigation
          height={400}
          slidesPerView={1}>
            { images.map((image, index) => (
              <SwiperSlide key={`image-${index}`}>
                <div className="gallery-item-wrapper gallery-image-item">
                  <img src={image} alt=""/>
                </div>
              </SwiperSlide>
            )) }
        </Swiper>
        <div className="gallery-close-wrapper">
          <span onClick={() => onClose()}><FontAwesomeIcon icon={faTimes} /></span>
        </div>
      </div>
    </div>
  )
}

export default Gallery